import * as React from 'react';
import { FC } from 'react';

import { capitalize } from 'lodash-es';
import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import { Box, withTypography } from 'components/ui';
import { usePrevious } from 'hooks/use-previous';
import { selectors, useAppSelector } from 'state/global-state';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { spacing } from 'styles/constants';
import { getItemLoyaltyRewardDiscount } from 'utils/cart/helper';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { IPrice } from '../types';

const RewardsFreeText = withTypography({ fontFamily: 'heading' });

const PriceFree = () => {
  const rewardsFreeText = capitalize(t('free'));
  return (
    <Box style={styles.freePrice} focusable accessibilityLabel={rewardsFreeText}>
      <RewardsFreeText>{rewardsFreeText}</RewardsFreeText>
    </Box>
  );
};

export const Price: FC<React.PropsWithChildren<IPrice>> = ({ item, isOffer, rewardApplied }) => {
  const price = priceForCartEntry(item);

  const { formatCurrencyForLocale } = useUIContext();
  const appliedLoyaltyRewards = useAppSelector(selectors.loyalty.selectAppliedLoyaltyRewards);
  const isRewardApplied = Boolean(rewardApplied && !isOffer);
  const discountPrice =
    price - getItemLoyaltyRewardDiscount({ cartEntry: item, appliedLoyaltyRewards });
  const prevDiscountPrice = usePrevious(discountPrice);
  const discountDisplay = rewardApplied ? discountPrice : prevDiscountPrice;

  const beforeDiscountPriceLabel = `${formatCurrencyForLocale(price)} ${
    rewardApplied ? t('beforeDiscount') : ''
  }`;

  const afterDiscountLabel = `${discountDisplay} ${t('afterDiscount')}`;

  return (
    <Box style={styles.priceContainer}>
      {rewardApplied && discountPrice === 0 ? (
        <PriceFree />
      ) : (
        <Currency
          amount={isRewardApplied ? discountDisplay : price}
          textProps={{
            accessibilityLabel: discountDisplay ? afterDiscountLabel : beforeDiscountPriceLabel,
          }}
          isBold
        />
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  freePrice: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  priceContainer: {
    alignItems: 'flex-end',
    marginLeft: spacing.$2,
  },
});
